import Link from 'next/link';
import { Button } from '@/components/ui/button';
import HeaderInteractive from './HeaderInteractive';

function ArrowRightIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" aria-hidden="true">
      <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
    </svg>
  );
}

function MenuIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2D2D2D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" aria-hidden="true">
      <path d="M4 5h16"/><path d="M4 12h16"/><path d="M4 19h16"/>
    </svg>
  );
}

function HomeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2D2D2D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" aria-hidden="true">
      <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"/><path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    </svg>
  );
}

function MessageSquarePlusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2D2D2D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" aria-hidden="true">
      <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/><path d="M12 8v6"/><path d="M9 11h6"/>
    </svg>
  );
}

export default function Header() {
  return (
    <>
      <header
        className="header-fixed touch-none"
        style={{
          position: 'fixed', top: 0, left: 0, right: 0,
          backgroundColor: '#FFFFFF', zIndex: 1000,
          boxShadow: 'none', transition: 'box-shadow 0.2s ease-in-out',
          maxWidth: '100vw', boxSizing: 'border-box', width: '100%', margin: 0,
        }}
      >
        <div className="mobile-padding header-main-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '20px', paddingBottom: '20px' }}>
          {/* Logo */}
          <Link href="/" className="header-logo builder-hide-on-mobile" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', zIndex: 1001, flexShrink: 0 }}>
            <img src="/logo-black.svg" alt="Receipt Maker" className="w-auto h-8 md:h-[35px]" style={{ height: '32px', width: 'auto' }} />
          </Link>

          {/* Builder home icon - CSS shows only on mobile builder */}
          <button className="builder-home-icon" style={{ display: 'none', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', zIndex: 1001, flexShrink: 0 }} aria-label="Go to homepage">
            <HomeIcon />
          </button>

          <div id="builder-subheader-portal" className="builder-inline-controls" />

          {/* Mobile Feedback - builder only */}
          <button className="mobile-header-button builder-show-only header-feedback-btn" style={{ background: 'none', border: '1px solid #E5E5E5', borderRadius: '4px', cursor: 'pointer', padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }} aria-label="Send Feedback">
            <MessageSquarePlusIcon />
          </button>

          {/* Mobile My Templates - filled by HeaderInteractive when signed in */}
          <div id="header-my-templates-mobile-slot" />

          {/* Mobile Create */}
          <Link href="/builder" className="mobile-header-button">
            <Button className="gap-2 font-semibold flex items-center justify-center transition-colors" style={{ fontFamily: 'Roboto', fontWeight: 500, fontSize: '14px', lineHeight: '20px', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', backgroundColor: '#0068D6', color: '#FFF', border: 'none', boxShadow: 'none' }}>
              Create
            </Button>
          </Link>

          {/* Desktop Nav */}
          <nav className="desktop-nav" style={{ display: 'flex', gap: '40px', alignItems: 'center' }}>
            <Link href="/templates" style={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: '16px', color: '#2D2D2D', textDecoration: 'none' }}>Templates</Link>
            {/* My Templates link injected by HeaderInteractive when signed in */}
            <div id="header-my-templates-desktop-slot" style={{ display: 'contents' }} />
          </nav>

          {/* Right side */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', zIndex: 1001 }}>
            <Link href="/builder" prefetch={false} className="desktop-button builder-hide-cta">
              <Button className="font-semibold flex items-center justify-center gap-2 transition-colors" style={{ fontFamily: 'Roboto', fontWeight: 500, fontSize: '16.9px', lineHeight: '24px', padding: '12px 24px', borderRadius: '4px', cursor: 'pointer', backgroundColor: '#0068D6', color: '#FFF', border: 'none', boxShadow: 'none' }}>
                Make a receipt
                <ArrowRightIcon />
              </Button>
            </Link>

            <div id="header-account-slot" className="desktop-button" style={{ display: 'none' }} />

            <button className="mobile-menu-button" aria-label="Toggle menu" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MenuIcon />
            </button>
          </div>
        </div>
      </header>

      <div className="header-spacer" style={{ height: '76px' }} />

      <HeaderInteractive />
    </>
  );
}
